import React from 'react'
import { ShimmerTable, ShimmerPostDetails } from "react-shimmer-effects";

const ShimmerEffect = () => {
    return (
        <ShimmerTable row={5} col={5} />
        // <div className="skeleton-blog">
        //     <header>
        //         <div className="skeleton-avatar">
        //         </div>

        //         <div className="skeleton-author">
        //         </div>
        //     </header>

        //     <main className="skeleton-image">
        //     </main>

        //     <footer className="skeleton-footer">
        //     </footer>
        // </div>
    )
}

export default ShimmerEffect